import { Injectable } from '@angular/core';
import { SocoHttpService } from '@app/soco/http';
import { GasContactUs } from '../models/gas-contact-us.model';
import { Observable, Subject } from 'rxjs';
import { ApiResult } from '@app/soco/core';

@Injectable({
    providedIn: 'root'
})
export class ContactUsService {
    sharedValue$ = new Subject();

    constructor(private http: SocoHttpService) { }

    addContactUsDetails(model: GasContactUs): Observable<ApiResult<any>> {
        return this.http.post<GasContactUs>({
            url: 'ContactUs/AddGasContactUsDetails',
            data: model,
            shouldIgnoreInvalidResult: false,
            pleaseWaitTimeoutDuration: 500,
            pleaseWaitMessage: 'Processing',
            pleaseWaitContainerId: 'ContainerAwaiter2'

        });
    }
}
